export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string; allowedRoles?: string[] }
  children?: INavigationRoute[]
}

import { getUserRole } from '../../utils/userRoleUtils'

const userRole = getUserRole()
const filterRoutesByRole = (routes: INavigationRoute[], role: string): INavigationRoute[] => {
  return routes
    .filter((route) => {
      if (route.meta.allowedRoles && route.meta.allowedRoles.includes(role)) {
        return true
      }
      if (!route.meta.allowedRoles) {
        return true
      }
      return false
    })
    .map((route) => {
      if (route.children) {
        route.children = filterRoutesByRole(route.children, role)
      }
      return route
    })
}

const sidebarRoutes = {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: filterRoutesByRole(
    [
      {
        name: 'dashboard',
        displayName: 'Developer Dashboard',
        meta: {
          icon: 'dashboard',
          allowedRoles: ['developer'],
        },
        children: [
          {
            name: 'dashboard',
            displayName: 'API Overview',
            meta: {
              icon: 'overview',
              allowedRoles: ['developer'],
            },
          },
          {
            name: 'analytics',
            displayName: 'API Analytics',
            meta: {
              icon: 'analytics',
              allowedRoles: ['developer'],
            },
          },
        ],
      },
      {
        name: 'api-management',
        displayName: 'API Management',
        meta: {
          icon: 'api',
          allowedRoles: ['developer'],
        },
        children: [
          {
            name: 'api-keys',
            displayName: 'API Keys',
            meta: {
              icon: 'vpn_key',
              allowedRoles: ['developer'],
            },
          },
          {
            name: 'webhooks',
            displayName: 'Webhooks',
            meta: {
              icon: 'webhook',
              allowedRoles: ['developer'],
            },
          },
          {
            name: 'api-documentation',
            displayName: 'API Documentation',
            meta: {
              icon: 'description',
              allowedRoles: ['developer'],
            },
          },
        ],
      },
      {
        name: 'integrations',
        displayName: 'Integrations',
        meta: {
          icon: 'integration_instructions',
          allowedRoles: ['developer'],
        },
        children: [
          {
            name: 'uber-integration',
            displayName: 'Uber Integration',
            meta: {
              icon: 'directions_car',
              allowedRoles: ['developer'],
            },
          },
          {
            name: 'aeversa-integration',
            displayName: 'Aeversa Integration',
            meta: {
              icon: 'battery_charging_full',
              allowedRoles: ['developer'],
            },
          },
          {
            name: 'calendar-integration',
            displayName: 'Calendar Integration',
            meta: {
              icon: 'today',
              allowedRoles: ['developer'],
            },
          },
        ],
      },
      {
        name: 'monitoring',
        displayName: 'API Monitoring',
        meta: {
          icon: 'monitor',
          allowedRoles: ['developer'],
        },
        children: [
          {
            name: 'api-logs',
            displayName: 'API Logs',
            meta: {
              icon: 'list_alt',
              allowedRoles: ['developer'],
            },
          },
          {
            name: 'error-tracking',
            displayName: 'Error Tracking',
            meta: {
              icon: 'bug_report',
              allowedRoles: ['developer'],
            },
          },
          {
            name: 'performance',
            displayName: 'Performance Metrics',
            meta: {
              icon: 'speed',
              allowedRoles: ['developer'],
            },
          },
        ],
      },
      {
        name: 'testing',
        displayName: 'API Testing',
        meta: {
          icon: 'science',
          allowedRoles: ['developer'],
        },
        children: [
          {
            name: 'test-auth',
            displayName: 'Auth Testing',
            meta: {
              icon: 'security',
              allowedRoles: ['developer'],
            },
          },
          {
            name: 'test-role',
            displayName: 'Role Testing',
            meta: {
              icon: 'admin_panel_settings',
              allowedRoles: ['developer'],
            },
          },
        ],
      },
      {
        name: 'reports',
        displayName: 'Developer Reports',
        meta: {
          icon: 'assessment',
          allowedRoles: ['developer'],
        },
        children: [
          {
            name: 'reports',
            displayName: 'API Usage Reports',
            meta: {
              icon: 'assessment',
              allowedRoles: ['developer'],
            },
          },
          {
            name: 'integration-reports',
            displayName: 'Integration Reports',
            meta: {
              icon: 'integration_instructions',
              allowedRoles: ['developer'],
            },
          },
          {
            name: 'odometer-reports',
            displayName: 'Odometer Reports',
            meta: {
              icon: 'speed',
              allowedRoles: ['developer'],
            },
          },
          {
            name: 'charging-reports',
            displayName: 'Charging Reports',
            meta: {
              icon: 'battery_charging_full',
              allowedRoles: ['developer'],
            },
          },
        ],
      },
      {
        name: 'preferences',
        displayName: 'Profile',
        meta: {
          icon: 'manage_accounts',
          allowedRoles: ['developer'],
        },
      },
    ],
    userRole,
  ),
}

export default sidebarRoutes
